import React, { useCallback } from "react";

import { useTranslation } from "react-i18next";

import SkeletonDetails from "../../../../../../../../components/Generic/LoadingSkeleton";
import SideViewComponent, {
  Navigation,
  PropHandles,
} from "../../../../../../../../components/Generic/ViewJobComponent";
import { StorageBoxType } from "../../../../../../../../models/storage.box.type";
import { DetailsTab } from "./Details";

interface Props {
  storageBoxType?: StorageBoxType;
  sideViewRef: React.RefObject<PropHandles>;
  loading: boolean;
}

export const StorageBoxTypeViewModal = ({ storageBoxType, sideViewRef, loading }: Props) => {
  const { t: translate } = useTranslation();

  const handleSetTabs = useCallback(() => {
    const tabs = [
      {
        key: Navigation.DETAILS,
        loading,
        isEmpty: !storageBoxType,
        render: () => <DetailsTab value={storageBoxType} />,
        renderLoading: () => <SkeletonDetails />,
      },
    ];

    return tabs;
  }, [storageBoxType]);

  const handleSetNavigation = useCallback(() => {
    const navList = [{ key: Navigation.DETAILS }];

    return navList;
  }, [storageBoxType]);

  const getTitle = useCallback(() => {
    if (storageBoxType?.name) return storageBoxType?.name;

    return translate("storageBoxType");
  }, [storageBoxType]);

  return (
    <SideViewComponent
      ref={sideViewRef}
      job={storageBoxType}
      isLoading={loading}
      title={getTitle()}
      navigation={handleSetNavigation()}
      tabs={handleSetTabs()}
    />
  );
};
